import API, { config } from './_main';
import { AxiosPromise } from 'axios';
import {CarCollisionDetailsResponse,CarCollisionIdsResponse,CollisionTokenResponse} from '../Models/CollisionModel';

export function getCollisionWithToken(token:string):AxiosPromise<CarCollisionDetailsResponse> {
    return API.get(`collision/token/${token}`)
}

export function getCollision(crashId: number): AxiosPromise<CarCollisionDetailsResponse> {
    return API.get(`collision/${crashId}`, config());
}

export function getCollisionList(filter?:URLSearchParams): AxiosPromise<CarCollisionIdsResponse> {
    return API.get(`collision`, config(filter));
}

export function getCollisionToken(collisionId:number):AxiosPromise<CollisionTokenResponse> {
    return API.post(`collision/${collisionId}/token`, config());
}


// WEBPACK FOOTER //
// ./src/Connectors/CollisionConnector.ts